import { DoctorOfficee } from '@illustrations';
import { Button, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import { IUserProviderItem } from 'types/provider.types';
import { ProviderInvitedItemSC } from './provider-invited.styled';
import { Provider } from '@illustrations';

interface ProviderInvitedProps {
  items: IUserProviderItem[];
  onContinue?: () => void;
}

const ProviderInvited: React.FunctionComponent<ProviderInvitedProps> = ({ items, onContinue }) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <DoctorOfficee />
      </div>
      <Typography
        display="h3"
        align="center"
        style={{
          padding: `0 ${theme.spacings.component.S}px`,
          marginTop: theme.spacings.text.XL,
          marginBottom: theme.spacings.text.XXL,
        }}
      >
        {formatMessage({ id: 'provider.onboarding.invited.title' })}
      </Typography>
      {items.map((item) => (
        <ProviderInvitedItemSC key={item.provider.id}>
          <div className="img-wrapper">
            {item.provider.logoUrl ? <img src={item.provider.logoUrl} /> : <Provider />}
          </div>
          <div className="content-wrapper">
            <Typography style={{ color: theme.color.tint.action }} display="h6">
              {item.provider.name}
            </Typography>
            <Typography
              display="captionLarge"
              style={{ color: theme.color.tint.secondary }}
            >{`${item.provider.address.address}, ${item.provider.address.postCode}, ${item.provider.address.city}`}</Typography>
          </div>
        </ProviderInvitedItemSC>
      ))}
      <div style={{ textAlign: 'center', marginTop: theme.spacings.text.XL }} onClick={onContinue}>
        <Button block={false} rightArrow>
          {formatMessage({ id: 'provider.onboarding.invited.start' })}
        </Button>
      </div>
    </>
  );
};

export default ProviderInvited;
